var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0071bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a043c1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dice",
    d: "M15,35.5a2.476,2.476,0,1,0-1.775-.725A2.414,2.414,0,0,0,15,35.5Zm0-18a2.51,2.51,0,0,0,1.775-4.275,2.51,2.51,0,0,0-3.55,3.55A2.414,2.414,0,0,0,15,17.5Zm9,9a2.476,2.476,0,1,0-1.775-.725A2.414,2.414,0,0,0,24,26.5Zm9,9a2.476,2.476,0,1,0-1.775-.725A2.414,2.414,0,0,0,33,35.5Zm0-18a2.51,2.51,0,0,0,1.775-4.275,2.51,2.51,0,0,0-3.55,3.55A2.414,2.414,0,0,0,33,17.5ZM9,42a2.878,2.878,0,0,1-2.1-.9A2.878,2.878,0,0,1,6,39V9a2.878,2.878,0,0,1,.9-2.1A2.878,2.878,0,0,1,9,6H39a2.878,2.878,0,0,1,2.1.9A2.878,2.878,0,0,1,42,9V39a3.076,3.076,0,0,1-3,3Zm0-3H39V9H9ZM9,9V9Z",
    transform: "translate(-6 -6)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.d61eb624862746e5c8df7aa9578dba54.svg";
export { ForwardRef as ReactComponent };